/**
 * Schreibstube (Pilot 11.10.2026, Arbeitsblock 12.10.2026) – reine Logik der Seite (ohne React), Fachregeln liegen im Backend (services/schreibstube*.py).
 * Versandwege: Brief, E-Mail, Fax (Fax ueber den bestehenden Placetel-Mail-to-Fax-Aufbau; im Pilot nur lokale Testsenke). eBO folgt spaeter.
 */
export const VERSANDWEGE = [
  { key: 'brief', label: 'Brief (Post)' },
  { key: 'email', label: 'E-Mail' },
  { key: 'fax', label: 'Fax' },
];
export const SPAETERE_VERSANDWEGE = [{ key: 'ebo', label: 'EGVP/eBO (nur Simulation)' }];

export const ANSCHRIFT_FELDER = ['strasse', 'hausnummer', 'plz', 'ort'];

export const FELDER = ['klient_id', 'empfaenger_ref', 'empfaenger_name', 'empfaenger_ansprechpartner', 'empfaenger_anschrift', 'empfaenger_adresse',
  'empfaenger_email', 'empfaenger_fax', 'empfaenger_telefon', 'versandweg', 'absender_user_id', 'sachgebiet', 'bezug', 'aufgabe_id', 'vorgang_id', 'ist_antwort_auf',
  'betreff', 'inhalt', 'datum', 'anrede', 'anrede_manuell'];

// Briefaufbau (12.10.2026): ANREDE -> TEXTKOERPER -> GRUSSFORMEL -> ABSENDER. Die Anrede ist ein eigener Briefteil (nicht Teil des Textfelds).
export const ANREDE_STANDARD = 'Sehr geehrte Damen und Herren,';
export const GRUSSFORMEL = 'Mit freundlichen Grüßen';
export const STANDARD_TEXT = '';
const EMAIL_RX = /^[^@\s<>,;]+@[^@\s<>,;]+\.[A-Za-z]{2,}$/;
const PLATZHALTER_RX = /\{\{\s*[A-Za-z_]+\s*\}\}|\[fehlt:[^\]]*\]/g;

export function neuerToken() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `t-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function leererEntwurf(klientId = '', aufgabeId = null) {
  return {
    id: null, version: null, status: 'entwurf', client_token: neuerToken(), klient_id: klientId, empfaenger_ref: null, empfaenger_name: '',
    empfaenger_ansprechpartner: '', empfaenger_anschrift: null, empfaenger_adresse: '', empfaenger_email: '', empfaenger_fax: '', empfaenger_telefon: '',
    versandweg: null, absender_user_id: null, sachgebiet: null, bezug: null, aufgabe_id: aufgabeId || null, vorgang_id: null, ist_antwort_auf: null,
    betreff: '', inhalt: STANDARD_TEXT, datum: null, anrede: ANREDE_STANDARD, anrede_manuell: false, anhaenge: [],
  };
}

/** Request-Body: nur fachliche Felder (Erfasser/Akteur kommt serverseitig aus der Anmeldung, nie aus dem Body). */
export function entwurfBody(e) {
  const b = {};
  FELDER.forEach((f) => { b[f] = e[f] === undefined ? null : e[f]; });
  b.anhang_ids = anhangIds(e);                          // Anlagen aus der Akte (Server prueft: nur derselbe Klient)
  return b;
}

export function refGleich(a, b) {
  return !!a && !!b && a.typ === b.typ && a.id === b.id;
}

export function refSchluessel(ref) {
  return ref ? `${ref.typ}:${ref.id}` : '';
}

export function bezugOptionen(sachgebiete, key) {
  const s = (sachgebiete || []).find((x) => x.key === key);
  return s ? s.bezug || [] : [];
}

/** Bezug nach Sachgebietswechsel: genau ein vorhandener Wert -> vorbelegt, sonst leer (nie erfunden). */
export function bezugFuer(sachgebiete, key, bisher) {
  const opt = bezugOptionen(sachgebiete, key);
  if (bisher && opt.some((o) => o.wert === bisher.wert && o.quelle === bisher.quelle)) return bisher;
  const werte = Array.from(new Set(opt.map((o) => o.wert)));
  return werte.length === 1 ? opt[0] : null;
}

/** Versandweg nur vorschlagen, wenn genau ein Kanal beim Empfaenger hinterlegt ist. */
function versandwegVorschlag(empfaenger) {
  const kanaele = [empfaenger.adresse && 'brief', empfaenger.email && 'email', empfaenger.fax && 'fax'].filter(Boolean);
  return kanaele.length === 1 ? kanaele[0] : null;
}

/** Empfaenger aus der Akte gewaehlt: Anschrift/E-Mail/Fax aus der Beziehung, Versandweg + Sachgebiet nur vorschlagen, wenn noch leer. */
export function mitEmpfaenger(e, empfaenger, sachgebiete) {
  if (!empfaenger) {
    return { ...e, empfaenger_ref: null, empfaenger_name: '', empfaenger_ansprechpartner: '', empfaenger_anschrift: null, empfaenger_adresse: '',
      empfaenger_email: '', empfaenger_fax: '', empfaenger_telefon: '' };
  }
  const versandweg = e.versandweg || versandwegVorschlag(empfaenger);
  const sachgebiet = e.sachgebiet || empfaenger.sachgebiet_vorschlag || null;
  return {
    ...e, empfaenger_ref: empfaenger.ref, empfaenger_name: empfaenger.name, empfaenger_anschrift: null, empfaenger_adresse: empfaenger.adresse || '',
    empfaenger_email: empfaenger.email || '', empfaenger_fax: empfaenger.fax || '', empfaenger_telefon: empfaenger.telefon || '', versandweg, sachgebiet,
    bezug: bezugFuer(sachgebiete, sachgebiet, sachgebiet === e.sachgebiet ? e.bezug : null),
  };
}

// ---- IN DER SACHE -> AN (12.10.2026): Context Resolver liegt im Server (kontext.sachgebiete[].aufloesung), hier nur angewendet
export function aufloesungFuer(sachgebiete, key) {
  const s = (sachgebiete || []).find((x) => x.key === key);
  return (s && s.aufloesung) || null;
}

function eintragFuer(kontext, ref) {
  return ref && kontext ? (kontext.empfaenger || []).find((x) => refGleich(x.ref, ref)) || null : null;
}

/** Empfaenger darf beim Sachgebietswechsel neu aufgeloest werden: AN ist leer ODER steht unveraendert auf der automatischen Aufloesung
 *  des bisherigen Sachgebiets (gleicher Eintrag, Kontaktdaten unveraendert). Alles andere ist eine Nutzerentscheidung -> nie still ueberschreiben. */
export function empfaengerErsetzbar(e, kontext) {
  if (!e.empfaenger_ref) {
    return !e.empfaenger_anschrift && ['empfaenger_name', 'empfaenger_ansprechpartner', 'empfaenger_adresse', 'empfaenger_email', 'empfaenger_fax', 'empfaenger_telefon']
      .every((f) => !(e[f] || '').trim());
  }
  const a = aufloesungFuer(kontext && kontext.sachgebiete, e.sachgebiet);
  const x = eintragFuer(kontext, e.empfaenger_ref);
  if (!a || a.status !== 'eindeutig' || !refGleich(a.ref, e.empfaenger_ref) || !x) return false;
  return (e.empfaenger_name || '') === (x.name || '') && (e.empfaenger_adresse || '') === (x.adresse || '') && (e.empfaenger_email || '') === (x.email || '')
    && (e.empfaenger_fax || '') === (x.fax || '') && (e.empfaenger_telefon || '') === (x.telefon || '') && !(e.empfaenger_ansprechpartner || '').trim();
}

/** Sachgebiet gewaehlt/gewechselt: Bezug neu (nur vorhandene Werte), AN neu aufloesen, soweit ersetzbar -- genau ein Treffer -> vorbelegt, sonst leer. */
export function mitSachgebiet(e, key, kontext) {
  const sachgebiete = kontext ? kontext.sachgebiete : [];
  const n = { ...e, sachgebiet: key || null, bezug: bezugFuer(sachgebiete, key, null) };
  if (!kontext || !empfaengerErsetzbar(e, kontext)) return n;
  const a = aufloesungFuer(sachgebiete, key);
  const neu = a && a.status === 'eindeutig' ? eintragFuer(kontext, a.ref) : null;
  const alt = eintragFuer(kontext, e.empfaenger_ref);
  // Versandweg, der nur aus dem alten automatischen Empfaenger vorgeschlagen war, nicht stehen lassen
  const versandweg = alt && e.versandweg && e.versandweg === versandwegVorschlag(alt) ? null : e.versandweg;
  return mitEmpfaenger({ ...n, versandweg }, neu, sachgebiete);
}

/** AN-Liste fuer das Sachgebiet: nur fachlich passende Empfaenger (der aktuell gewaehlte bleibt immer sichtbar). */
export function empfaengerFuerSachgebiet(empfaenger, key, gewaehlt) {
  if (!key) return empfaenger || [];
  return (empfaenger || []).filter((x) => (x.passt_zu || []).includes(key) || refGleich(x.ref, gewaehlt));
}

/** Manuell gewaehlter Empfaenger passt fachlich nicht (mehr) zum Sachgebiet -> Hinweis, Nutzer entscheidet. */
export function empfaengerPasstNicht(e, kontext) {
  if (!e.sachgebiet || !e.empfaenger_ref) return false;
  const x = eintragFuer(kontext, e.empfaenger_ref);
  return !!x && !(x.passt_zu || []).includes(e.sachgebiet);
}

/** Wechsel auf freie Eingabe: Verknuepfung loesen, bisher sichtbare Angaben bleiben als Startwerte stehen. */
export function alsFreierEmpfaenger(e) {
  return { ...e, empfaenger_ref: null, empfaenger_anschrift: e.empfaenger_anschrift || null };
}

export function setzeAnschrift(e, feld, wert) {
  const a = { strasse: '', hausnummer: '', plz: '', ort: '', ...(e.empfaenger_anschrift || {}), [feld]: wert };
  return { ...e, empfaenger_anschrift: a };
}

export function anschriftText(a) {
  if (!a) return '';
  const strHnr = [a.strasse, a.hausnummer].filter(Boolean).join(' ');
  const plzOrt = [a.plz, a.ort].filter(Boolean).join(' ');
  return strHnr && plzOrt ? `${strHnr}\n${plzOrt}` : '';
}

export function faxGueltig(n) {
  const t = (n || '').trim();
  return /^\+?[0-9 ()/-]{6,30}$/.test(t) && t.replace(/\D/g, '').length >= 6;
}

export function offenePlatzhalter(...texte) {
  return Array.from(new Set(texte.flatMap((t) => (t || '').match(PLATZHALTER_RX) || []))).sort();
}

// ---- Briefaufbau: spiegelt services/schreibstube.py (anrede_fuer / trenne_anrede / nur_textkoerper / komposition); der Server ist verbindlich
const FRAU_HERR_RX = /^(frau|herrn?)\s+(.+?)[,\s]*$/i;
const ANREDE_ZEILE_RX = /^\s*((?:sehr\s+geehrte[rs]?|guten\s+tag|hallo|liebe[rs]?)\b[^\n]{0,150})[ \t]*(?:\n|$)\s*/i;
const GRUSS_ENDE_RX = /(?:\n\s*)*mit\s+freundlichen\s+gr(?:ü|ue)(?:ß|ss)en[,.!]?\s*$/i;
const GRUSS_IRGENDWO_RX = /mit\s+freundlichen\s+gr(?:ü|ue)(?:ß|ss)en/i;

function frauHerr(text) {
  const m = FRAU_HERR_RX.exec((text || '').trim());
  if (!m) return '';
  return m[1].toLowerCase() === 'frau' ? `Sehr geehrte Frau ${m[2]},` : `Sehr geehrter Herr ${m[2]},`;
}

/** Deterministische Anrede ohne Geschlechtsvermutung (nur ausdrueckliches "Frau …"/"Herr …"). */
export function anredeFuer(typ, name, ansprechpartner = '') {
  const ap = (ansprechpartner || '').trim();
  if (ap) return frauHerr(ap) || `Guten Tag ${ap},`;
  const n = (name || '').trim();
  if (typ === 'np') return frauHerr(n) || (n ? `Guten Tag ${n},` : ANREDE_STANDARD);
  return frauHerr(n) || ANREDE_STANDARD;
}

/** Automatische Anrede fuer den aktuellen Empfaenger; null = (noch) nicht bestimmbar (Kontext nicht geladen) -> nichts aendern. */
export function autoAnrede(e, empfaenger) {
  const ap = (e.empfaenger_ansprechpartner || '').trim();
  if (e.empfaenger_ref) {
    const x = (empfaenger || []).find((y) => refGleich(y.ref, e.empfaenger_ref));
    if (!x) return null;
    return ap ? anredeFuer(null, '', ap) : (x.anrede_vorschlag || ANREDE_STANDARD);
  }
  return anredeFuer(null, e.empfaenger_name, ap);
}

/** Empfaengerwechsel: automatische Anrede nachziehen -- manuelle Anrede und aeltere Entwuerfe (anrede=null) bleiben unberuehrt. */
export function mitAutoAnrede(e, empfaenger) {
  if (e.anrede === null || e.anrede === undefined || e.anrede_manuell) return e;
  const a = autoAnrede(e, empfaenger);
  return a === null || a === e.anrede ? e : { ...e, anrede: a };
}

export function trenneAnrede(text) {
  const t = (text || '').replace(/^\n+/, '');
  const m = ANREDE_ZEILE_RX.exec(t);
  return m ? [m[1].trim(), t.slice(m[0].length)] : ['', text || ''];
}

export function ohneGrussformel(text) {
  return (text || '').trimEnd().replace(GRUSS_ENDE_RX, '').trimEnd();
}

export function nurTextkoerper(text) {
  return ohneGrussformel(trenneAnrede(text)[1]).replace(/^\n+|\n+$/g, '');
}

/** Dieselbe Reihenfolge wie PDF/E-Mail: [{teil, text}] */
export function komposition(e, absender) {
  const name = (absender && absender.name) || '';
  const titel = (absender && absender.titel) || '';
  const teile = [];
  if (e.anrede !== null && e.anrede !== undefined && (e.anrede || '').trim()) teile.push({ teil: 'anrede', text: e.anrede.trim() });
  teile.push({ teil: 'text', text: ohneGrussformel(e.inhalt) });
  teile.push({ teil: 'gruss', text: GRUSSFORMEL });
  if (name) teile.push({ teil: 'absender', text: [name, titel].filter(Boolean).join('\n') });
  return teile;
}

export function aufbauMaengel(e) {
  if (e.anrede === null || e.anrede === undefined) return [];
  const m = [];
  const koerper = ohneGrussformel(e.inhalt);
  if ((e.anrede || '').trim() && trenneAnrede(koerper)[0]) {
    m.push('Der Text beginnt mit einer zweiten Anrede – die Anrede steht bereits im Feld „Anrede“. Bitte eine davon entfernen.');
  }
  if (GRUSS_IRGENDWO_RX.test(koerper)) m.push('Der Text enthält „Mit freundlichen Grüßen“ – die Grußformel setzt Olympus selbst unter den Text. Bitte im Text entfernen.');
  return m;
}

/** Aelterer Entwurf (Anrede im Text): nur auf ausdrueckliche Nutzeraktion in eigene Briefteile zerlegen. */
export function anredeAusTextLoesen(e, empfaenger) {
  const [anrede] = trenneAnrede(e.inhalt);
  const neu = { ...e, inhalt: nurTextkoerper(e.inhalt), anrede: anrede || '', anrede_manuell: !!anrede };
  return anrede ? neu : mitAutoAnrede(neu, empfaenger);
}

/** Vorbelegung aus einem ZEO-Vorschlag ("In Schreibstube oeffnen"). */
export function ausZeoVorschlag(v, messageId) {
  const e = leererEntwurf(v.klient_id);
  FELDER.forEach((f) => { if (v[f] !== undefined && v[f] !== null) e[f] = v[f]; });
  e.inhalt = nurTextkoerper(e.inhalt);           // Anrede/Grussformel setzt Olympus selbst (automatische Anrede)
  e.anrede = '';
  e.anrede_manuell = false;
  e.zeo_message_id = messageId || null;
  e.hinweise = v.hinweise || [];
  e.pruefung = v.pruefung || null;              // Pruefansicht (Quellen/Belegarten) -- getrennt vom Brief, nie im PDF
  return e;
}

export function istGeaendert(e, gespeichert) {
  if (!gespeichert) return true;
  return FELDER.some((f) => JSON.stringify(e[f] ?? null) !== JSON.stringify(gespeichert[f] ?? null))
    || JSON.stringify(anhangIds(e)) !== JSON.stringify(anhangIds(gespeichert));
}

/** Anlagen: [{id, titel}] -> [id] (Reihenfolge = Auswahl). */
export function anhangIds(e) {
  return ((e && e.anhaenge) || []).map((a) => a.id);
}

/** Anlage hinzufuegen (ohne Doppelte) bzw. entfernen. */
export function mitAnlage(e, anlage) {
  return anhangIds(e).includes(anlage.id) ? e : { ...e, anhaenge: [...(e.anhaenge || []), { id: anlage.id, titel: anlage.titel }] };
}
export function ohneAnlage(e, id) {
  return { ...e, anhaenge: (e.anhaenge || []).filter((a) => a.id !== id) };
}

/** Spiegelt services/schreibstube.versand_maengel (der Server prueft verbindlich). */
export function versandMaengel(e) {
  const m = [];
  const adresse = anschriftText(e.empfaenger_anschrift) || (e.empfaenger_adresse || '').trim();
  if (!e.empfaenger_ref && !(e.empfaenger_name || '').trim()) m.push('Empfänger wählen oder Name/Institution eingeben.');
  if (!VERSANDWEGE.some((v) => v.key === e.versandweg)) m.push('Versandweg wählen (Brief, E-Mail oder Fax).');
  if (e.versandweg === 'email' && !EMAIL_RX.test(e.empfaenger_email || '')) m.push('Für E-Mail eine gültige Empfänger-Adresse angeben.');
  if (e.versandweg === 'fax' && !faxGueltig(e.empfaenger_fax)) m.push('Für Fax eine gültige Faxnummer angeben.');
  if (e.versandweg === 'fax' && (e.anhaenge || []).length) m.push('Per Fax wird nur das Schreiben übertragen – Anlagen bitte entfernen oder per E-Mail bzw. Brief senden.');
  if (e.versandweg === 'brief' && !adresse) m.push('Für den Brief die Postanschrift des Empfängers angeben.');
  if (!e.absender_user_id) m.push('Absender wählen.');
  if (!(e.betreff || '').trim()) m.push('Betreff fehlt.');
  if (!(e.inhalt || '').trim()) m.push('Brieftext fehlt.');
  const offen = offenePlatzhalter(e.betreff, e.anrede, e.inhalt);
  if (offen.length) m.push(`Offene Platzhalter: ${offen.join(', ')} – bitte ausfüllen.`);
  return m.concat(aufbauMaengel(e));
}

/** Text an der Cursorposition einfuegen -> { text, cursor }. Ohne bekannte Cursorposition (start=null): ans Ende des Textkoerpers. */
export function fuegeEin(text, start, ende, einschub) {
  const t = text || '';
  if (start === null || start === undefined) {
    const basis = t.replace(/\s+$/, '');
    const neu = basis ? `${basis}\n\n${einschub}` : einschub;
    return { text: neu, cursor: neu.length };
  }
  const a = Math.max(0, Math.min(start ?? t.length, t.length));
  const b = Math.max(a, Math.min(ende ?? a, t.length));
  return { text: t.slice(0, a) + einschub + t.slice(b), cursor: a + einschub.length };
}

/** Schluessel fuer die Live-Vorschau: aendert sich nur, wenn sich das Schreiben inhaltlich aendert. */
export function vorschauSchluessel(e) {
  return JSON.stringify(entwurfBody(e));
}

/** URL des EINEN Korrespondenz-Arbeitsplatzes (alte /schreibstube-Links fuehren dorthin). */
export function schreibstubeUrl({ brief, zeoVorschlag, klient, aufgabe, aktion } = {}) {
  const p = new URLSearchParams();
  if (brief) p.set('brief', brief);
  if (zeoVorschlag) p.set('zeo_vorschlag', zeoVorschlag);
  if (klient) p.set('klient', klient);
  if (aufgabe) p.set('aufgabe', aufgabe);
  if (aktion) p.set('aktion', aktion);
  const s = p.toString();
  return s ? `/korrespondenz?${s}` : '/korrespondenz';
}

/** Spaltenbreiten (Liste / Vorschau) begrenzen. */
export function begrenze(wert, min, max) {
  return Math.max(min, Math.min(max, Math.round(wert)));
}

export const STATUS_LABEL = { entwurf: 'Entwurf', versand_laeuft: 'Versand läuft', versendet: 'Versendet' };

// ---- Verbesserungen 26.10.2026 -----------------------------------------------------------------------------------------------------
export function emailGueltig(t) {
  return EMAIL_RX.test((t || '').trim());
}

const EMAIL_IM_TEXT_RX = /<?([^@\s<>,;]+@[^@\s<>,;]+\.[A-Za-z]{2,})>?/g;

/** Spiegelt services/schreibstube.name_und_email: genau EINE gueltige Adresse im Empfaengerfeld -> [name, email], sonst [text, '']. */
export function nameUndEmail(text) {
  const t = (text || '').trim();
  const treffer = Array.from(t.matchAll(EMAIL_IM_TEXT_RX)).map((m) => m[1]);
  if (treffer.length !== 1 || !EMAIL_RX.test(treffer[0])) return [t, ''];
  const rest = t.replace(EMAIL_IM_TEXT_RX, ' ').replace(/\s+/g, ' ').replace(/^[\s,;:"'-]+|[\s,;:"'-]+$/g, '');
  return [rest || treffer[0], treffer[0]];
}

/** Freie Eingabe: Empfaengerfeld setzen. Steht dort eine Adresse und ist das E-Mail-Feld leer (oder nur daraus uebernommen),
 *  wird sie als E-Mail-Adresse gefuehrt -- eine selbst eingetragene E-Mail-Adresse wird nie ueberschrieben, der Name bleibt wie getippt. */
export function mitFreiemNamen(e, name) {
  const bisher = nameUndEmail(e.empfaenger_name)[1];
  const verknuepft = !(e.empfaenger_email || '').trim() || (bisher && e.empfaenger_email === bisher);
  return { ...e, empfaenger_name: name, empfaenger_email: verknuepft ? nameUndEmail(name)[1] : e.empfaenger_email };
}

export function plzGueltig(plz) {
  return /^\d{5}$/.test((plz || '').trim());
}

/** Orte zur PLZ: genau ein Vorschlag und Ort noch leer -> automatisch eintragen; sonst nichts aendern (Nutzer waehlt oder tippt). */
export function mitOrtVorschlag(e, plz, orte) {
  const a = e.empfaenger_anschrift || {};
  if ((a.plz || '') !== plz || (a.ort || '').trim() || (orte || []).length !== 1) return e;
  return setzeAnschrift(e, 'ort', orte[0]);
}

export const ANLAGE_ENDUNGEN = ['.pdf', '.jpg', '.jpeg', '.png', '.tif', '.tiff', '.docx', '.xlsx', '.odt', '.txt'];
export const ANLAGE_MAX_BYTES = 15 * 1024 * 1024;

/** Vorpruefung vor dem Upload (der Server prueft verbindlich, auch den Inhalt): Fehlertext oder null. */
export function anlageVorpruefung(datei) {
  if (!datei) return 'Keine Datei gewählt.';
  const name = (datei.name || '').toLowerCase();
  const endung = name.includes('.') ? name.slice(name.lastIndexOf('.')) : '';
  if (!ANLAGE_ENDUNGEN.includes(endung)) return 'Dieser Dateityp ist als Anlage nicht erlaubt (erlaubt: PDF, JPG, PNG, TIFF, DOCX, XLSX, ODT, TXT).';
  if (!datei.size) return 'Die Datei ist leer.';
  if (datei.size > ANLAGE_MAX_BYTES) return 'Die Datei ist größer als 15 MB.';
  return null;
}

/** Markierter Text im Textkoerper (fuer „Als Textbaustein speichern“): '' wenn nichts markiert ist. */
export function markierterText(text, auswahl) {
  if (!auswahl || auswahl[0] === null || auswahl[1] === undefined) return '';
  const [a, b] = auswahl;
  return b > a ? (text || '').slice(a, b).trim() : '';
}

/** Eigene Textbausteine (Kategorie „textbaustein“ der bestehenden Vorlagenverwaltung) nach Suchbegriff filtern. */
export function filtereBausteine(liste, q) {
  const s = (q || '').trim().toLowerCase();
  return (liste || []).filter((b) => !s || (b.name || '').toLowerCase().includes(s) || (b.inhalt || '').toLowerCase().includes(s));
}

/** Hauptaufgaben fuer „Unteraufgabe von …“: nur offene Aufgaben, die selbst keine Unteraufgabe sind. */
export function hauptaufgaben(aufgaben) {
  return (aufgaben || []).filter((a) => !a.eltern_aufgabe_id);
}

/** Speicherzustand fuer die Kopfzeile. */
export function speicherZustand(e, gespeichert, speichert) {
  if (speichert) return { text: 'Wird gespeichert …', art: 'laeuft' };
  if (e.status && e.status !== 'entwurf') return { text: '', art: 'fertig' };
  if (!e.id) return { text: 'Noch nicht gespeichert', art: 'neu' };
  return istGeaendert(e, gespeichert) ? { text: 'Ungespeicherte Änderungen', art: 'geaendert' } : { text: 'Alle Änderungen gespeichert', art: 'gespeichert' };
}
